import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Footer from '../components/footer-view';
import { meSupportExperience } from 'modules/me-module';
import appconfig from 'config/appconfig';
import { getSupportExperienceUrls } from 'lib/utility-functions';

export class FooterContainer extends Component {
  render() {
    return (
      <Footer
        showSupportLink={this.props.supportExperience !== appconfig.supportExperiences.HIDE}
        supportUrls={getSupportExperienceUrls(this.props.supportExperience)}
        currentYear={new Date().getFullYear()}
      />
    );
  }
}

FooterContainer.propTypes = {
  supportExperience: PropTypes.string.isRequired,
};

export const mapStateToProps = (state) => ({
  supportExperience: meSupportExperience(state) || appconfig.supportExperiences.DEFAULT,
});

export default connect(mapStateToProps)(FooterContainer);
